import { motion } from 'framer-motion'

export function NotificationSkeleton() {
  return (
    <div className="p-4 border-b border-gray-100">
      <div className="flex items-start gap-3">
        {/* Type Icon Skeleton */}
        <div className="flex-shrink-0">
          <motion.div
            className="w-5 h-5 bg-gray-200 rounded-full"
            animate={{
              opacity: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 1.5,
              repeat: Number.POSITIVE_INFINITY,
              ease: 'easeInOut',
            }}
          />
        </div>

        {/* Content Skeleton */}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-2">
            {/* Category Badge Skeleton */}
            <motion.div
              className="h-5 bg-gray-200 rounded-full w-16"
              animate={{
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 1.5,
                repeat: Number.POSITIVE_INFINITY,
                ease: 'easeInOut',
                delay: 0.1,
              }}
            />
            {/* Unread Indicator Skeleton */}
            <motion.div
              className="w-2 h-2 bg-gray-200 rounded-full"
              animate={{
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 1.5,
                repeat: Number.POSITIVE_INFINITY,
                ease: 'easeInOut',
                delay: 0.2,
              }}
            />
          </div>

          {/* Title Skeleton */}
          <motion.div
            className="h-4 bg-gray-200 rounded w-3/4 mb-2"
            animate={{
              opacity: [0.5, 1, 0.5],
            }}
            transition={{
              duration: 1.5,
              repeat: Number.POSITIVE_INFINITY,
              ease: 'easeInOut',
              delay: 0.3,
            }}
          />

          {/* Message Skeleton */}
          <div className="space-y-2 mb-3">
            <motion.div
              className="h-3 bg-gray-200 rounded w-full"
              animate={{
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 1.5,
                repeat: Number.POSITIVE_INFINITY,
                ease: 'easeInOut',
                delay: 0.4,
              }}
            />
            <motion.div
              className="h-3 bg-gray-200 rounded w-2/3"
              animate={{
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 1.5,
                repeat: Number.POSITIVE_INFINITY,
                ease: 'easeInOut',
                delay: 0.5,
              }}
            />
          </div>

          {/* Footer Skeleton */}
          <div className="flex items-center justify-between">
            <motion.div
              className="h-3 bg-gray-200 rounded w-20"
              animate={{
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 1.5,
                repeat: Number.POSITIVE_INFINITY,
                ease: 'easeInOut',
                delay: 0.6,
              }}
            />
            <motion.div
              className="h-6 bg-gray-200 rounded w-12"
              animate={{
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 1.5,
                repeat: Number.POSITIVE_INFINITY,
                ease: 'easeInOut',
                delay: 0.7,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
